import SubscriptionTypeFilter from "./SubscriptionTypeFilter"

export default  SubscriptionTypeFilter;



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubscriptionAdvancedFilter/filters/SubscriptionTypeFilter/index.js